"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateListenStatus = exports.updateReadStatus = exports.updateWordStatus = exports.getPassageDetailsById = void 0;
const base_1 = require("./base");
const const_1 = require("./const");
// import { mockPassageDetails } from "./passage-details.mock";
const getPassageDetailsById = (id) => __awaiter(void 0, void 0, void 0, function* () {
    // return mockPassageDetails;
    return (0, base_1.get)(const_1.BASE_PATH + "/content/get-passage-by-id", true, {
        id,
    });
});
exports.getPassageDetailsById = getPassageDetailsById;
const updateWordStatus = (passageId, status) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(const_1.BASE_PATH + "/status/word", {
        passageId,
        status,
    }, true);
});
exports.updateWordStatus = updateWordStatus;
const updateReadStatus = (passageId, status) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(const_1.BASE_PATH + "/status/read", {
        passageId,
        status: status,
    }, true);
});
exports.updateReadStatus = updateReadStatus;
const updateListenStatus = (passageId, status) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(const_1.BASE_PATH + "/status/listen", {
        passageId,
        status,
    }, true);
});
exports.updateListenStatus = updateListenStatus;
